import React from 'react';

export function LoadingSpinner({ label = 'Loading...' }) {
  return (
    <div role="status" aria-live="polite" className="loading-spinner">
      <span className="loading-spinner__indicator" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export default LoadingSpinner;